// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5dbb853c","198":"86af5dcf","244":"d155b64a","325":"ded4e35e","330":"985c25cb","344":"f9db25ff","381":"726edab5","404":"1d0b8b28","465":"3c158ac5","498":"0a9b79c0","569":"a96b30b6","653":"93a65aea","780":"d8467e02","951":"a2a04b52"}[chunkId] + ".chunk.js";
};